import { api } from 'application/api'
import { unmarkFavoriteMessageSucceed } from 'application/redux/actions/pages/akten'
import { call, put } from 'redux-saga/effects'

export function* unmarkFavoriteMessageSaga(action) {
    yield call(api.gateway.pages.deleteMarkFavoriteMessage, action.accountId, action.messageId)
    yield put(unmarkFavoriteMessageSucceed())
}
